export class CandidatesQueryFilter {
    parentCompanyId: any;
    loggedInUserId: any;
    status: any[] = [];
    roleList: any[] = [];
    recruiterList: any[] = [];
    vendors: any[] = [];
    requisitionNumbers: any[] = [];
    clientOrBuList: any[] = [];
    firstName = '';
    lastName = '';
    email = '';
    phone = '';
    requisitionStatus: any[] = [];
    workflowStates: any[] = [];
    workLocationIds: any[] = [];
    visibility: any[] = [];
    searchString = '';
    pageSize = 12;
    pageNum: any = '';
    candidateType = 'OWN_CANDIDATES';
    jobTypes: any[] = [];
    jobSubTypes: any[] = [];
    sponsorships: any[] = [];
    includeWithoutCompensation = true;
    salary: any = null;
    salaryDuration = 'PER_YEAR';
    rate: any = null;
    rateDuration = 'PER_HOUR';
    currency = 'USD';
    // the below properties cannot be empty and should be added as per requirement
    // column;
    // sortDirection;

    constructor(companyId: any, userId: any) {
        this.parentCompanyId = companyId;
        this.loggedInUserId = userId;
    }
}
